module.exports = __webpack_public_path__ + "static/media/door0201.0faa2581.jpg";